import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Toast } from 'primereact/toast';

import AddPolicyForm from './AddPolicyForm';
import '../../styles/mastercertificate.css';
import '../../styles/pages.css';

export default function AddNewPolicyPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const toast = React.useRef<Toast>(null);

  const insuredId: string   = (location.state as any)?.insuredId   ?? '';
  const insuredName: string = (location.state as any)?.insuredName ?? '';

  const handleSuccess = (created: { databaseId: string | null; policyNumber: string }) => {
    toast.current?.show({
      severity: 'success',
      summary: 'Policy Created Successfully',
      detail: `Policy "${created.policyNumber}" has been added${insuredName ? ` for ${insuredName}` : ''}. Redirecting...`,
      life: 2500,
    });
    setTimeout(() => navigate('/agentdashboard'), 2000);
  };

  return (
    <div className="sendCertPage__container">
      <Toast ref={toast} />

      {/* ── Page Header ─────────────────────────────────────────────────── */}
      <div style={{ paddingBottom: 16, borderBottom: '1px solid #e6e7ef', marginBottom: 0 }}>
        <div className="masterCert__pageTitle" style={{ fontSize: '1.15rem', textAlign: 'left' }}>
          Add New Policy
        </div>
        {insuredName && (
          <div style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>
            <i className="pi pi-user" style={{ fontSize: 11, marginRight: 4 }} />
            {insuredName}
          </div>
        )}
      </div>

      <AddPolicyForm
        insuredId={insuredId}
        insuredName={insuredName}
        onSuccess={handleSuccess}
        onCancel={() => navigate(-1)}
      />
    </div>
  );
}
